import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Search } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setModPartyMasterHelpStatus } from '../utility/Redux/modal';
import ModPartyMasterHelp from '../master/partyMasterHelp';

export function ShopkeeperForm({
  onSubmit,
  initialData,
  onCancel,
}) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    shop_name: '',
    mobile: '',
    contact_person: '',
    address: '',
    city: '',
    pin_code: '',
    party_id: undefined,
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        shop_name: initialData.shop_name,
        mobile: initialData.mobile,
        contact_person: initialData.contact_person,
        address: initialData.address,
        city: initialData.city,
        pin_code: initialData.pin_code,
        party_id: initialData.party_id,
        account_no:initialData.account_no
      });
    } else {
      setFormData({
        shop_name: '',
        mobile: '',
        contact_person: '',
        address: '',
        city: '',
        pin_code: '',
        party_id: undefined,
      });
    }
  }, [initialData]);

  const handlePartySelect = (row) => {
    const party = row.row
    setFormData({
      shop_name: party.NAME,
      mobile: party.MOBILE,
      contact_person: party.NAME,
      address: party.ADDRESS,
      city: party.CITY,
      pin_code: party.PIN_CODE,
      account_no:party.ACCOUNT_NO
    });

    dispatch(setModPartyMasterHelpStatus(false));
  };

  const handleCancel = () => {
    setFormData({
      shop_name: '',
      mobile: '',
      contact_person: '',
      address: '',
      city: '',
      pin_code: '',
      party_id: undefined,
    });

    if (onCancel) onCancel();
  };

  const handleSave = () => {
    onSubmit(formData);
  };

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>
            {initialData ? "Edit Shopkeeper" : "Add New Shopkeeper"}
          </CardTitle>
        </CardHeader>

        <CardContent>
          <div className="grid gap-6">
            <div className="grid gap-2">
              <Label>Shop Name</Label>
              <div className="flex gap-2">
                <Input
                  readOnly
                  value={formData.shop_name}
                />
                <Button
                  type="button"
                  variant="outline"
                  className="gap-2"
                  onClick={() => dispatch(setModPartyMasterHelpStatus(true))}
                >
                  <Search className="h-4 w-4" />
                  Search
                </Button>
              </div>
            </div>

            <div className="grid gap-2">
              <Label>Contact Person</Label>
              <Input onChange={e => {
                setFormData(f => {
                  return {
                    ...f,
                    contact_person:e.target.value
                  }
                })
              }} value={formData.contact_person} />
            </div>

            <div className="grid gap-2">
              <Label>Mobile</Label>
              <Input readOnly value={formData.mobile} maxLength={10} />
            </div>

            <div className="grid gap-2">
              <Label>Address</Label>
              <Input readOnly value={formData.address} />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="grid gap-2">
                <Label>City</Label>
                <Input readOnly value={formData.city} />
              </div>

              <div className="grid gap-2">
                <Label>Pin Code</Label>
                <Input readOnly value={formData.pin_code} maxLength={6} />
              </div>
            </div>

            <div className="flex gap-2 pt-4">
              <Button className="flex-1" type="button" onClick={handleSave}>
                {initialData ? "Update" : "Save"} Shopkeeper
              </Button>

              {(initialData || onCancel) && (
                <Button type="button" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      <ModPartyMasterHelp
        onRowClick={handlePartySelect}
        onClose={() => dispatch(setModPartyMasterHelpStatus(false))}
      />
    </>
  );
}
